<template>
  <Dialog
    :open="isModalOpen"
    class="fixed inset-0 z-50 py-6 overflow-auto bg-white sm:bg-transparent sm:p-6 sm:p-12"
    @closeModal="closeModal"
    @click.self="closeModal"
  >
    <div
      class="max-w-4xl px-6 mx-auto bg-white sm:px-16 md:px-24 sm:py-10 sm:rounded-lg sm:shadow z-50 relative"
    >
      <div class="absolute xs:top-1r sm:top-1r md:top-1r lg:top-1r right-1r">
        <button
          class="h-6 w-6 flex items-center justify-center"
          @click="closeModal"
        >
          <span class="sr-only">Close</span>
          <CloseIcon />
        </button>
      </div>
      <DialogPanel>
        <DialogTitle
          class="flex justify-center mt-6 text-xl leading-tight text-center sm:text-2xl md:text-3xl my-10"
        >
          Not so fast...
        </DialogTitle>
        <DialogDescription>
          <ExclamationTriangleIcon
            class="text-help-warning w-16 h-16 mx-auto"
          />
          <p class="text-center mt-10 mb-2">
            Warning, there is less than a 2-day turnaround between this booking
            and the previous or following booking. Do you want to proceed?
          </p>
        </DialogDescription>
        <div class="flex justify-center mt-14">
          <BaseButton class="mr-10" outlined @click.self="closeModal">
            Cancel
          </BaseButton>
          <BaseButton @click.self="continueAssignment">
            Continue
          </BaseButton>
        </div>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script setup>
import { defineEmits } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogDescription,
} from "@headlessui/vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
import BaseButton from "@/components/shared/Button/BaseButton.vue";

const props = defineProps({
  isModalOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["onCancel", "onContinue"]);
const closeModal = () => {
  emit("onCancel");
};

const continueAssignment = () => {
  emit("onContinue");
};
</script>
